<!-- eslint-disable @angular-eslint/template/no-inline-styles -- Need to use an inline style to define a CSS variable. -->
<mat-card [style.--transition-duration]="transitionDuration"
          class="relative h-full w-full rounded-xl p-0 overflow-hidden mat-elevation-z4 transition-transform ease-in-out duration-[var(--transition-duration)]
          [transform-style:preserve-3d] [-webkit-transform-style:preserve-3d] motion-reduce:transition-none"
          [ngClass]="{ '[transform:rotateY(0deg)]': frontSelected, '[transform:rotateY(-180deg)]': !frontSelected }"
>
  @if ({barcode: patronSelectors.barcode | select}; as vm) {
    <!-- FRONT OF CARD -->
    <section class="@container/front size-full flex flex-col justify-between items-start gap-y-4 px-5 py-3 transition-opacity duration-0 bg-surface1"
             [class.opacity-0]="!frontVisible" [class.pointer-events-none]="!frontVisible" [class.opacity-100]="frontVisible"
    >
      @if (organizationSelectors.hasBanner | select) {
        <img [src]="organizationSelectors.bannerUrl | select" [alt]="organizationSelectors.name | select" class="max-h-[3.375rem] max-w-full"/>
      } @else {
        <div class="flex flex-row justify-start items-center gap-x-2 w-full">
          <mat-icon color="primary" class="material-icons-outlined shrink-0 mat-icon-size-9">local_library</mat-icon>
          <p class="text-headline-small">{{ organizationSelectors.name | select }}</p>
        </div>
      }

      @if (patronSelectors.patron | select; as patron) {
        <px-patron-status [patron]="patron"/>
      }

      <div class="w-full">
        <p class="text-headline-small @[15.25rem]/front:text-headline-medium">{{ vm.barcode | format:'CARD_NUMBER' }}</p>

        <div class="flex flex-row justify-between items-center">
          <p class="text-body-medium @[15.25rem]/front:text-body-large">Valid Through
            {{ patronSelectors.accountExpiration | select | format:'DATE_MONTH_DAY_YEAR' }}</p>

          <mx-outlined-button [customContentTemplate]="barcodeIcon" [renderAsIconOnly]="true" tooltip="Show barcode" (click)="onClickShowBackButton()"/>
        </div>
      </div>
    </section>

    <!-- BACK OF CARD -->
    <section
      class="@container/back absolute inset-0 flex flex-col justify-end items-center gap-y-4 px-5 py-3
              [transform:rotateY(-180deg)] transition-opacity duration-0 bg-surface-container-lowest"
      [class.opacity-0]="frontVisible" [class.pointer-events-none]="frontVisible" [class.opacity-100]="!frontVisible"
    >
      <mx-barcode [value]="vm.barcode" [barHeightRem]="3.3625" [includeValueDisplay]="true" [valueDisplayFormatAsCard]="true"
                  valueDisplayTypography="text-headline-small @[15.25rem]/back:text-headline-medium"/>

      <mx-action-buttons class="w-full">
        <mx-outlined-button startIcon="arrow_back" tooltip="Return to front" (click)="onClickShowFrontButton()"/>
      </mx-action-buttons>
    </section>
  }
</mat-card>

<ng-template #barcodeIcon>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" class="w-6 h-6">
    <path fill-rule="evenodd" clip-rule="evenodd"
          d="M2 6H3V18H2V6ZM4 6H6V18H4V6ZM8 6H9V18H8V6ZM10 6H13V18H10V6ZM14 6H15V18H14V6ZM17 6H18V18H17V6ZM19 6H20V18H19V6ZM21 6H22V18H21V6Z" fill="#414941"/>
  </svg>
</ng-template>
